import React from "react";
import { Link } from "react-router-dom";
import { Mail, Facebook } from "lucide-react";
import Reveal from "./Reveal";
import AppStoreBadge from "./AppStoreBadge";
import { brand, footer, links } from "../mock";

const FooterCTA = () => {
  return (
    <footer className="relative bg-velis-dark overflow-hidden">
      {/* Gold glow */}
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/3 w-[900px] h-[700px] opacity-45 pointer-events-none"
        style={{ backgroundImage: "url(/images/gold-glow.jpg)", backgroundSize: "cover", backgroundPosition: "center", mixBlendMode: "screen" }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-24 pb-16 text-center">
        <Reveal>
          {/* Boussole VÉLIS circulaire (détourée) avec halo doré doux */}
          <div className="relative mx-auto mb-8 w-[106px] h-[106px] flex items-center justify-center">
            <div
              className="absolute inset-0 -m-10 rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(224,168,90,0.45) 0%, rgba(224,168,90,0.18) 42%, rgba(224,168,90,0) 72%)" }}
            />
            <img
              src="/images/velis-compass-round.png"
              alt="Boussole VÉLIS"
              className="relative w-[106px] h-[106px] object-contain"
            />
          </div>

          <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.08]">
            {footer.title}
          </h2>
          <p className="mt-6 text-white/75 text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed">
            {footer.subtitle}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <AppStoreBadge />
            <a
              href={links.support}
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-white/25 text-white font-semibold px-6 py-3 hover:bg-white/10"
            >
              <Mail size={18} /> Nous contacter
            </a>
          </div>
        </Reveal>
      </div>

      {/* Bottom bar */}
      <div className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <span className="velis-wordmark text-white text-lg block">{brand.name}</span>
            <p className="text-velis-orange text-sm mt-2 font-display">{footer.motto}</p>
            <a href={`mailto:${footer.email}`} className="text-white/50 text-sm hover:text-white mt-1 inline-block">
              {footer.email}
            </a>
            <div className="mt-3">
              <a href={links.social.facebook} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-velis-orange inline-block" aria-label="Facebook">
                <Facebook size={26} />
              </a>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/45">
          <span>© {new Date().getFullYear()} VÉLIS. Tous droits réservés.</span>
          <div className="flex items-center gap-6">
            <Link to={links.privacy} className="hover:text-white">Politique de confidentialité</Link>
            <Link to={links.terms} className="hover:text-white">Conditions d’utilisation</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterCTA;
